import { i18n } from "@lingui/core";
import { t } from "@lingui/macro";
import { Affix, Flex } from "antd";

import { OrderListItem } from "../../api";
import CardStatistic from "../partials/Cards/CardStatistic";
import { formatDatePeriod } from "../partials/Cards/utils";
import styles from "./BudgetSummaryOverlay.module.less";

interface BudgetSummaryOverlayProps {
  selectedCampaigns: OrderListItem[];
  visible: boolean;
}

const BudgetSummaryOverlay = ({
  selectedCampaigns,
  visible,
}: BudgetSummaryOverlayProps) => {
  const totalBudget = selectedCampaigns.reduce(
    (sum, campaign) => sum + campaign.budget,
    0
  );

  const campaignsCount =
    selectedCampaigns.length -
    selectedCampaigns.filter((campaign) => campaign.spreadedSecondPart).length;

  const datePeriod = (() => {
    if (selectedCampaigns.length === 0) return "";
    // Find earliest startDate
    const firstStartDate = selectedCampaigns.reduce(
      (earliest, campaign) =>
        campaign.startDate < earliest ? campaign.startDate : earliest,
      selectedCampaigns[0].startDate
    );

    // Find latest endDate
    const lastEndDate = selectedCampaigns.reduce(
      (latest, campaign) =>
        campaign.endDate > latest ? campaign.endDate : latest,
      selectedCampaigns[0].endDate
    );

    return formatDatePeriod(firstStartDate, lastEndDate);
  })();

  const totalBudgetLabel = `€ ${totalBudget.toLocaleString("nl-NL", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;

  if (!visible || selectedCampaigns.length === 0) {
    return null;
  }

  return (
    <Affix offsetBottom={0} className={styles.budgetSummaryOverlay}>
      <Flex className={styles.summaryContent} justify="space-between">
        <Flex>
          <CardStatistic label={i18n._(t`Aantal:`)} value={campaignsCount} />
          <CardStatistic label={i18n._(t`Periode:`)} value={datePeriod} />
        </Flex>

        <CardStatistic
          className={styles.budgetItem}
          label={i18n._(t`Totaal budget:`)}
          value={totalBudgetLabel}
        />
      </Flex>
    </Affix>
  );
};

export default BudgetSummaryOverlay;
